import React from "react";
import MarketingLayout from "../components/MarketingLayout";
import { BRAND } from "../data/brand";

const EFFECTIVE = "1 January 2025";

function H2({ children }) {
  return <h2 style={{ fontSize: 18, fontWeight: 700, color: "#dde6f0", margin: "36px 0 10px" }}>{children}</h2>;
}
function P({ children }) {
  return <p style={{ fontSize: 14, color: "#6b7e94", lineHeight: 1.85, margin: "0 0 14px" }}>{children}</p>;
}
function Li({ children }) {
  return <li style={{ fontSize: 14, color: "#6b7e94", lineHeight: 1.85, marginBottom: 6 }}>{children}</li>;
}

export default function PrivacyPolicy() {
  return (
    <MarketingLayout>
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "64px 24px 80px" }}>
        <div style={{ fontSize: 10, color: "#3b82f6", letterSpacing: 2, fontWeight: 800, marginBottom: 10, fontFamily: "'JetBrains Mono',monospace" }}>LEGAL</div>
        <h1 style={{ fontSize: "clamp(24px,4vw,36px)", fontWeight: 800, color: "#dde6f0", marginBottom: 8 }}>Privacy Policy</h1>
        <p style={{ fontSize: 12, color: "#2a3a4a", marginBottom: 40 }}>Effective date: {EFFECTIVE} · {BRAND.company}</p>

        <P>
          {BRAND.company} ("we", "us", "our") operates DPL Jade at {BRAND.website}. This policy explains what data we collect, how we use it, and your rights. By using DPL Jade you agree to this policy.
        </P>

        <H2>1. Information We Collect</H2>
        <P><strong style={{ color: "#8496a8" }}>Free / local plan:</strong> We collect no personal information. Your floor-plan data is stored exclusively in your browser's localStorage and never transmitted to our servers.</P>
        <P><strong style={{ color: "#8496a8" }}>Pro / Team plan (authenticated):</strong> When you sign in we collect:</P>
        <ul style={{ paddingLeft: 20, margin: "0 0 14px" }}>
          <Li>Your email address (used for authentication via magic link).</Li>
          <Li>Your floor-plan project data (DCEL state, project metadata) — stored in our Supabase-hosted database.</Li>
          <Li>Session tokens managed by Supabase Auth (stored in browser memory/localStorage).</Li>
        </ul>
        <P><strong style={{ color: "#8496a8" }}>Usage data:</strong> We may collect anonymised, aggregated analytics (page views, feature usage) via privacy-respecting tooling. This data contains no personally identifiable information.</P>

        <H2>2. How We Use Your Information</H2>
        <ul style={{ paddingLeft: 20, margin: "0 0 14px" }}>
          <Li>To provide, maintain and improve DPL Jade.</Li>
          <Li>To sync your projects across devices (Pro/Team).</Li>
          <Li>To send transactional emails (magic-link sign-in, receipts). We do not send marketing emails without your explicit consent.</Li>
          <Li>To comply with legal obligations.</Li>
        </ul>

        <H2>3. Data Storage & Security</H2>
        <P>Pro/Team project data is stored on Supabase infrastructure hosted in secure data centres. We apply row-level security so only authenticated owners can access their own data. All data in transit is encrypted via TLS 1.2+.</P>
        <P>Despite our best efforts, no internet transmission is 100% secure. We cannot guarantee absolute security.</P>

        <H2>4. Data Retention</H2>
        <P>We retain your account and project data for as long as your account is active. You may request deletion at any time by emailing <a href={`mailto:${BRAND.email}`} style={{ color: "#3b82f6" }}>{BRAND.email}</a>. Deletion is completed within 30 days.</P>

        <H2>5. Cookies</H2>
        <P>We use only strictly necessary cookies (Supabase session token). We do not use advertising or tracking cookies. No third-party cookies are set on our domain.</P>

        <H2>6. Third-Party Services</H2>
        <ul style={{ paddingLeft: 20, margin: "0 0 14px" }}>
          <Li><strong style={{ color: "#8496a8" }}>Supabase</strong> (supabase.com) — database, authentication, storage. Subject to Supabase's privacy policy.</Li>
          <Li><strong style={{ color: "#8496a8" }}>Vercel</strong> (vercel.com) — hosting and CDN. Subject to Vercel's privacy policy.</Li>
          <Li><strong style={{ color: "#8496a8" }}>Razorpay</strong> — payment processing (Pro/Team billing). We never store card details; all payment data is handled by Razorpay under their PCI-DSS compliance.</Li>
        </ul>

        <H2>7. Your Rights</H2>
        <P>Under applicable law (including India's DPDP Act 2023) you have the right to: access your personal data, correct inaccuracies, request deletion, and withdraw consent. Contact us at <a href={`mailto:${BRAND.email}`} style={{ color: "#3b82f6" }}>{BRAND.email}</a> to exercise any of these rights.</P>

        <H2>8. Children's Privacy</H2>
        <P>DPL Jade is not directed at children under 18. We do not knowingly collect personal data from minors. If you believe a minor has provided us data, contact us and we will delete it promptly.</P>

        <H2>9. Changes to This Policy</H2>
        <P>We may update this policy from time to time. We will notify registered users by email and update the effective date above. Continued use after changes constitutes acceptance.</P>

        <H2>10. Contact</H2>
        <P>
          {BRAND.company}<br />
          {BRAND.registeredAddress && <>{BRAND.registeredAddress}<br /></>}
          {BRAND.cin  && <>CIN: {BRAND.cin}<br /></>}
          {BRAND.gstin && <>GSTIN: {BRAND.gstin}<br /></>}
          Email: <a href={`mailto:${BRAND.email}`} style={{ color: "#3b82f6" }}>{BRAND.email}</a><br />
          Website: <a href={BRAND.website} style={{ color: "#3b82f6" }}>{BRAND.website}</a>
        </P>
      </div>
    </MarketingLayout>
  );
}
